import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import testwrap from 'assets/icons/brain.png'
import { getTestData } from "service/TestService";
import closeicon from 'assets/icons/lock.png'
import openicon from 'assets/icons/unlock.png'
import styles from "./TestBody.module.scss";
import moment from 'moment';
import { useNavigate } from 'react-router-dom'
import { Icon } from '../../../components/UnvUI/Icons'
const TestBody = ({ data, isadmin, log=null }) => {
  const { t } = useTranslation('common');
  const navigate = useNavigate()
 
  const [render, setRender] = useState(false)


  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  useEffect(() => {

    setRender(false)

  }, [render]);

  const handleClick = (id) => {
    if (typeof id !== "undefined") {
      navigate(`/worktest/`, { state: { usedId: id } });
    }
  };
  const handleClickTest = (id) => {
    if (typeof id !== "undefined") {
      navigate(`/useworktest/`, { state: { usedId: id } });
    }
  };

  const formatDate = (dateString) => {
    const date = moment(dateString, 'DD.MM.YYYY HH:mm');
    const today = moment();

    if (date.isSame(today, 'day')) {
      return `${t('test.today_word')} ${date.format('HH:mm')}`;
    }
    else if (date.isSame(today, 'year')) {
      return date.format('DD MMMM HH:mm')
    }
    else {
      return date.format('DD MMMM YYYY HH:mm');
    }
  };

  return (
    <div>
      {data?.length === 0 ? (
        <div style={{
          padding: '48px 24px',
          textAlign: 'center',
          background: '#FFFFFF',
          borderRadius: '12px',
          border: '2px solid #F5F5F5'
        }}>
          <div style={{
            width: '80px',
            height: '80px',
            margin: '0 auto 20px',
            background: 'var(--color-accent-light)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '40px'
          }}><Icon name="clipboard" /></div>
          <h3 style={{ color: '#333333', margin: '0 0 12px 0', fontSize: '20px', fontWeight: '700' }}>
            {log === 0 ? t('test.no_completed_tests') : isadmin ? t('test.no_created_tests') : t('test.no_available_tests')}
          </h3>
          <p style={{ color: '#999999', margin: 0, fontSize: '15px' }}>
            {isadmin && log !== 0 ? t('test.create_first_test') : t('test.no_tests_in_section')}
          </p>
        </div>
      ) : (
        <div className={styles.test_card_wrapper}>
          <div className={styles.test_table_header}>
            <span>{t('test.col_name')}</span>
            {log !== 0 && isadmin && <span>{t('test.col_status')}</span>}
            {log === 0 && <span>{t('test.col_time')}</span>}
            <span>{log === 0 ? t('test.col_author') : t('test.col_date')}</span>
            <span>{t('test.col_actions')}</span>
          </div>
      {(log === 0) ? (
        <>  
          {[...data].map((item) => (
            <div key={item.id || item.worktest} className={styles.test_card}>
              <div>
                <p className={styles.title_test}>
                  <img src={testwrap} className={styles.img} alt={t('test.test_alt')} />
                  {item.employee_part_worktest_title}
                </p>
                {item.description && (
                  <p className={styles.description_text}>
                    {item.description}
                  </p>
                )}
              </div>
              <div className={styles.date_info}>
                <p className={styles.date_text}><Icon name="timer" /> {item.time_response}</p>
              </div>
              <div className={styles.date_info}>
                <p className={styles.employee_name}>{item.employee_name}</p>
              </div>
              <div className={styles.action_buttons}>
                <button
                  className={styles.open_btn}
                  onClick={() => handleClickTest(item.worktest)}
                >
                  {t('test.view_btn')}
                </button>
              </div>
            </div>
          ))}
        </>
      ) : (
        <>
          {[...data].map((item) => (
            <div key={item.id} className={styles.test_card}>
              <div>
                <p className={styles.title_test}>
                  <img src={testwrap} className={styles.img} alt={t('test.test_alt')} />
                  {item.title}
                </p>
                {item.description && (
                  <p className={styles.description_text}>
                    {item.description}
                  </p>
                )}
              </div>
              {isadmin && (
                <div>
                  <span className={`${styles.status_badge} ${item.activate ? styles.active : styles.inactive}`}>
                    <img
                      src={item.activate ? openicon : closeicon}
                      className={styles.img_status}
                      alt={item.activate ? t('test.status_open') : t('test.status_closed')}
                    />
                    {item.activate ? t('test.status_open') : t('test.status_closed')}
                  </span>
                </div>
              )}
              <div className={styles.date_info}>
                <p className={styles.employee_name}>{item.employee_name}</p>
                <p className={styles.date_text}>{formatDate(item.createdAt)}</p>
              </div>
              <div className={styles.action_buttons}>
                {isadmin ? (
                  <button
                    className={styles.open_btn}
                    onClick={() => handleClick(item.id)}
                  >
                    {t('test.watch_btn')}
                  </button>
                ) : (
                  <button
                    className={styles.open_btn}
                    onClick={() => handleClickTest(item.id)}
                  >
                    {t('test.pass_btn')}
                  </button>
                )}
              </div>
            </div>
          ))}
        </>
      )}
        </div>
      )}
    </div>
  );
};

export default TestBody;
